import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../store/store';
import JwtDecode from 'jwt-decode';
import { DecodedToken } from '../auth/authReducer';
import './Profile.scss';

export const UserAuditStamp = (): React.JSX.Element => {
  const token = useSelector((state: AppState) => state.auth.tokenResponse);
  const decodedToken = token && (JwtDecode(token.accessToken) as DecodedToken);

  return (
    <>
      <span>User: {decodedToken?.sub}</span>
      <span> - </span>
      <span>Timestamp: {new Date().toLocaleString()}</span>
    </>
  );
};

export default UserAuditStamp;
